// extracted by mini-css-extract-plugin
export default {"icon":"search_zero_results_help-module__icon--1Y8TM","link":"search_zero_results_help-module__link--3s2T8"};